import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import {MenuItem, LazyLoadEvent,} from 'primeng/api';
import {UserClaimService, UserRoleDefaultFeaturesService, ApplicationFeaturesService} from '../../../services';
import { IGlobalSearchParam, ISearchGlobalFilter } from '../../../../shared/models/Global-Search.model';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../../../shared/services/shared.service';

import { Router, ActivatedRoute } from '@angular/router';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
import { UserRoleDefaultFeatures } from 'src/app/admin/models';
import { ExcelService } from 'src/app/shared/services/excel.service';
import * as fs from 'file-saver';

@Component({
  selector: 'app-user-role-default-features',
  templateUrl: './user-role-default-features.component.html',
  styleUrls: ['./user-role-default-features.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class UserRoleDefaultFeaturesComponent implements OnInit {
  searchForm: FormGroup;
  userRole: any = [];
  userFeature:any = [];

  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  startSearch: boolean = false;
  applicationFeaturesList;
  gridSpinner = 'gridSpinner1';
  isSearchLoading: boolean = false;
  loading: boolean = false;
  applicationFeaturesSearchParam:IGlobalSearchParam;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  items: MenuItem[];
  applicationFeaturesSearchSpinner = 'applicationFeaturesSearchSpinner';
  ref: DynamicDialogRef;
  msgs: Message[] = [];
  dialogPosition = 'topright';
  isApplicationFeaturesAdd : boolean = false;
  isApplicationFeaturesEdit : boolean = false;
  buttonLabel: string = "";
  title: string = "";
  applicantForm:FormGroup;
  showAddRuleButton:boolean = false;

  ////mmm
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  gridGlobalFilter: SelectItem[];

  selectedGFilter: any;
  
  showTopFilters: boolean;
  isAdd: boolean = false;
  selectedGridMenuItem:any = null;
  showToggle:boolean;
  isshowpaginator:boolean=true;
  statusValues:any;
  selectedStatusId:any="All";
  selectedStatus:any;
   allColumns = [
    // { value: 'action', header: 'Action' },
    { value: 'featureName', header: 'Feature Name' },
    { value: 'roleName', header: 'Role Name' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
 //   { value: 'action', header: 'Action' },
    { value: 'featureName', header: 'Feature Name' },
    { value: 'roleName', header: 'Role Name' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;

  constructor(private userClaimService:UserClaimService,
    private userRoleDefaultFeaturesService: UserRoleDefaultFeaturesService,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private applicationFeaturesService:ApplicationFeaturesService,
    private excelService:ExcelService,
    private _router: Router
    ) { 
    this.InitialSetup();

    this.showFilters = false;
      this.showSorting = false;
      this.spinner.show();
      setTimeout(() => {
          this.spinner.hide();
      }, 1000);
      
    /*this.items = [
      {
        label: 'Delete',
        icon: 'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.userRoleFeaturesId)
      }
    ];*/
      //this.currentUser = this.storage.retrieve('currentuser');
      
      
  }

  InitialSetup(){
    this.searchForm = this._fb.group({
      userRoleFeaturesId: new FormControl(0),
      roleId: new FormControl(0, [Validators.required]),
      roleName: new FormControl(),
      featureId: new FormControl(0, [Validators.required]),
      featureName: new FormControl(),
      description: new FormControl(),
      isActive: new FormControl(),
      createdBy: new FormControl(1),
      createdOn: new FormControl(new Date()),
      modifiedBy: new FormControl(),
      modifiedOn: new FormControl()
    })
  }
  ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkDeletePermission();
    // this.getCompanyName();
    this.getUserRole();
    // this.getFeaturesNotAdded();

  let userRoleId : any[] = [1];
  this.searchGlobalFilter.push({ field:"gfilterrole", matchMode:"contains", value:userRoleId }) 
  /////mmm
  const customFilterName = "custom-equals";
  const notEquals = "not-equals";
  const dateAfter = "date-after";
  const dateBefore = "date-before";

  this.matchModeOptions = [
    { label: "Custom Equals", value: customFilterName },
    { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
    { label: "Contains", value: FilterMatchMode.CONTAINS }
  ];

  this.matchModeOptionsForDate = [
    { label: "Equals", value: customFilterName },
    { label: "Not Equals", value: notEquals },
    { label: "Greater Than", value: dateAfter },
    { label: "Less Than", value: dateBefore },
  ];

  this.matchModeOptionsForNumeric = [
    { label: "Custom Equals", value: customFilterName },
    { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
    { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
  ];



  this.filterCondition=[
    {fieldName:"featureName",type:"basic"},
    {fieldName:"roleName",type:"basic"},
    {fieldName:"isActive",type:"basic"},
    {fieldName:"createdBy",type:"basic"},
    {fieldName:"createdOn",type:"date"},

  ];

  this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
  this.getApplicationFeaturesList();
  this.statusValues=['All','Active',"Inactive"];
}
checkViewPermission()
{
  var result = this.sharedService.checkPermission("Admin_View");
  if(!result)
  this._router.navigateByUrl('/login');
}
getApplicationFeaturesList()
{



this.applicationFeaturesSearchParam = 
   {
     pageNo:this.pageNo,
     pageSize:this.pageSize,
     sortField:this.sortField,
     appliedFilters:this.appliedFilters,
     searchGlobalFilter: this.searchGlobalFilter,
     sortOrder:this.sortOrder
   };
   this.spinner.show(this.applicationFeaturesSearchSpinner);
// this.applicationFeaturesService.getAllApplicationFeatures(this.applicationFeaturesSearchParam).subscribe((data: any) => {
  this.userRoleDefaultFeaturesService.getAllUserRoleDefaultFeatures(this.applicationFeaturesSearchParam).subscribe((data: any) => {
  this.appliedFilters = [];
  this.applicationFeaturesList =data;
  this.isshowpaginator=this.applicationFeaturesList.length>0?true:false;
  console.log(this.applicationFeaturesList);
  this.totalRecords = data[0].totalCount;
  this.spinner.hide(this.applicationFeaturesSearchSpinner);
 });
}



loadApplicationFeaturesList(event:LazyLoadEvent)
{ 
this.appliedFilters = [];
this.loadEvent=event;
if(event.first==0)
{
  this.pageNo = 1;
}
else {
  this.pageNo=(event.first/event.rows)+1;
}
this.pageSize=event.rows;

this.pageSize=event.rows;

if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
{
  this.applyFilter();
  this.getApplicationFeaturesList();
}
this.oldPageNo = this.pageNo;
this.oldPageSize = this.pageSize;
this.filters=event.filters;
if(this.filters["createdOn"]!= undefined)
{
if(this.filters["createdOn"][0].matchMode == "date-after")
{
   this.showAddRuleButton = true;
}
else{
  this.showAddRuleButton = false;
}
}
this.sortField=event.sortField;
if(event.sortField === undefined || event.sortField === null)
{
  this.sortField='createdOn';
}
if(event.sortOrder === 1)
{
this.sortOrder='desc';
}
if(event.sortOrder === -1)
{
this.sortOrder='asc';
}
if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
{
  this.applyFilter();
  this.getApplicationFeaturesList()
}
this.oldSortField = this.sortField;
this.oldSortOrder = this.sortOrder;
}

applyFilter()
{
console.log(this.filterCondition.length);
console.log(this.filterCondition);
console.log(this.filters);
if (Object.keys(this.filters).length > 1)
{
  this.appliedFilters = [];
for(let i=0;i<this.filterCondition.length;i++)
{
  if(this.filterCondition[i].type == "checkbox")
  {
    if(this.filters[this.filterCondition[i].fieldName][0].value == true)
    {
      this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                value:"true"}) 
    }
    else if (this.filters[this.filterCondition[i].fieldName][0].value == false){
      this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                value:"false"}) 
    }
  }
  else if (this.filterCondition[i].type == "basic")
  {
    if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
    this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                              matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                              value:this.filters[this.filterCondition[i].fieldName][0].value }) 
  }
  else if (this.filterCondition[i].type == "date")
  {
    for(let j=0; j<= this.filters[this.filterCondition[i].fieldName].length-1; j++)
    {
      if(this.filters[this.filterCondition[i].fieldName][j].value !== null)
      this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                matchMode:this.filters[this.filterCondition[i].fieldName][j].matchMode,
                                value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")}) 
    }
  }
  else if (this.filterCondition[i].type == "numeric")
  {
    if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
    this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                              matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                              value:this.filters[this.filterCondition[i].fieldName][0].value }) 
  }
}
}
let userRoleIdval = this.searchForm.get('roleId').value;
let userRoleId : any[] = [userRoleIdval];
//this.searchGlobalFilter = [];
if(this.startSearch == true || this.startSearch == false)
{
  this.applicationFeaturesSearchParam = 
   {
     pageNo:this.pageNo,
     pageSize:this.pageSize,
     sortField:this.sortField,
     appliedFilters:this.appliedFilters,
     //searchGlobalFilter: this.searchGlobalFilter,
     sortOrder:this.sortOrder
   };
  this.spinner.show(this.applicationFeaturesSearchSpinner);
  this.userRoleDefaultFeaturesService.getAllUserRoleDefaultFeatures(this.applicationFeaturesSearchParam).subscribe((data: any) => {
  this.applicationFeaturesList =data;
  this.isshowpaginator=this.applicationFeaturesList.length>0?true:false;
  console.log(this.applicationFeaturesList);
  this.totalRecords = data[0].totalCount;
  this.spinner.hide(this.applicationFeaturesSearchSpinner);
  });
}
}





clearFilter(table: Table) {
  for (let i = 0; i < this.filterCondition.length; i++) {
    if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
     this.table.filters[this.filterCondition[i].fieldName][0].value = null;
    }
  }
table.clear();
this.selectedStatus="";
this.selectedStatusId=undefined;
this.appliedFilters = [];
// this.applyFilter();
this.getApplicationFeaturesList();
}

bindShowFilter() {
this.showFilters = (this.showFilters ? false : true)
}

bindShowSorting() {
this.showSorting = (this.showSorting ? false : true)
}

bindShowTopFilter() {
this.showTopFilters = (this.showTopFilters ? false : true)
}

applyFilterNew(table: Table){
  this.filters=table.filters;
  this.applyFilter();
}

changeGlobalFilter(event) {
if(event) {
  // this.previousVal = this.currentVal;
  this.selectedGFilter = event;
  console.log(this.selectedGFilter.value);
  this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value: this.selectedGFilter.value.value }) 
  this.getApplicationFeaturesList();
}
  // console.log('this.currentVal', this.selectedGFilter.value);
}





saveFilter()
{


}


  getUserRole(){
    this.userClaimService.getAllUserRole().subscribe(data => {
      this.userRole = data;
      if(this.userRole.length > 0){
        this.searchForm.get('roleId').setValue(this.userRole[0].id)
      }
      // if (data.length > 0) {
      //   for (let i = 0; i < data.length; i++) {
      //     this.userRole.push(data[i])
      //   }
      // }
     // this.getFeaturesNotAdded();
    },
    error =>{
      console.log(error);
    })
  }

  getFeaturesNotAdded(){
    let userRoleId = this.searchForm.get('roleId').value;
    console.log('userRoleId ' + userRoleId);
    this.userRoleDefaultFeaturesService.getFeaturesNotAddedForRoleId(userRoleId).subscribe(data => {
      this.userFeature = data;
      if(this.userFeature.length > 0){
        this.searchForm.get('featureId').setValue(this.userFeature[0].featureId)
      }else{
        this.searchForm.get('featureId').setValue(null)
      }
      // if (data.length > 0) {
      //   for (let i = 0; i < data.length; i++) {
      //     this.userFeature.push(data[i])
      //   }
      // }
    },
    error =>{
      console.log(error);
    })
  }

  search(){
    this.loading = true;
    // let companyId = this.searchForm.get('companyName').value;
    let userRoleId = this.searchForm.get('roleId').value;
    // let userName = this.searchForm.get('userName').value;
    // this.userClaimService.getUserList(companyId,userRoleId,userName).subscribe(data => {
    //   this.user = data;
    //   this.loading = false;
    // }, error => {
    //   console.log(error)
    // })
  }
  
  userRoleOnChange(id){
    this.userFeature = [];
    this.applyFilter();
    this.getFeaturesNotAdded();
  }

  add(){
    this.userFeature = [];
    this.getFeaturesNotAdded();
    this.isAdd = true;
  }

  cancel(){
    this.isAdd = false;
  }

  deleteConfirm(paramId:number) {
   
    this.dialogPosition = 'topright';
    this.confirmationService.confirm({
      message: 'Do you want to delete this user role features?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.loading = true;
        this.userRoleDefaultFeaturesService.deleteUserRoleDefaultFeatures(paramId).subscribe((data: any) => {
          this.getApplicationFeaturesList();
          this.getFeaturesNotAdded();
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
          this.loading = false;
         });
      },
      reject: (type) => {
        switch(type) {
            case ConfirmEventType.REJECT:
                this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
            break;
            case ConfirmEventType.CANCEL:
                this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
            break;
        }
      },
      key: "positionDialog"
    });
  }

  save({ value }: { value: UserRoleDefaultFeatures }) {
    this.loading = true;
    let role = this.userRole.filter(item => item.id == value.roleId);
    let features = this.userFeature.filter(item => item.featureId == value.featureId);
    if (role.length > 0) {
      value.roleName = role[0].name;
    }
    if (features.length > 0) {
      value.featureName = features[0].featureName;
      value.description = features[0].description;
      value.isActive = features[0].isActive;
    }
    this.userRoleDefaultFeaturesService.postUserRoleDefaultFeatures(value).subscribe(data => {
      this.getApplicationFeaturesList();
      this.isAdd = false;
      this.loading = false;
    }, error=> {
      console.log(error);
    })
  }

  exportExcel() {
    let header = ['Feature Name', 'Role Name', 'Is Active', 'Created By', 'Created On'];
    let jsonKey = ['featureName', 'roleName', 'isActive', 'createdByUser', 'createdOn'];
    let data = this.applicationFeaturesList;
    var arrFinalData = [];
    var columnsKeyNames = [];
    for (var i = 0; i < data.length; i++) {
      var singleRow_temp = data[i];
      columnsKeyNames = Object.keys(singleRow_temp);
      var column0_temp = "";
      var column1_temp = "";
      var column2_temp = "";
      var column3_temp = "";
      var column4_temp = "";
      for (var j = 0; j < columnsKeyNames.length; j++) {
        if (columnsKeyNames[j] == jsonKey[0]) {
          column0_temp = singleRow_temp[columnsKeyNames[j]];
        }
        if (columnsKeyNames[j] == jsonKey[1]) {
          column1_temp = singleRow_temp[columnsKeyNames[j]];
        }
        if (columnsKeyNames[j] == jsonKey[2]) {
          if(singleRow_temp[columnsKeyNames[j]] == true){
            column2_temp = 'ACTIVE';
          }
          if(singleRow_temp[columnsKeyNames[j]] == false){
            column2_temp = 'INACTIVE';
          }
        }
        if (columnsKeyNames[j] == jsonKey[3]) {
          if(singleRow_temp[columnsKeyNames[j]] != null && singleRow_temp[columnsKeyNames[j]] != undefined){
            column3_temp = singleRow_temp[columnsKeyNames[j]].firstName;
          }else{
            column3_temp = "";
          }
        }
        if (columnsKeyNames[j] == jsonKey[4]) {
          column4_temp = this.datepipe.transform(singleRow_temp[columnsKeyNames[j]],'MM/dd/yyyy');
        }
      }
      arrFinalData.push([column0_temp,column1_temp,column2_temp,column3_temp,column4_temp])
    }
    this.excelService.exportExcel(header,arrFinalData,'application-role-default')
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      console.log("length is "+tempColumn.length);
      return true;
    }
    return false;
  }

  checkDeletePermission() {
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if(isAdminDelete){
      var deleteItem =  {
        label: 'Delete',
        icon: 'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.userRoleFeaturesId)
       }
       this.items.push(deleteItem);
    }
  }

  getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }

 exportUserDefaultFeatures() {
  this.applyFilter();
  this.applicationFeaturesSearchParam = 
  {
    pageNo:this.pageNo,
    pageSize:this.pageSize,
    sortField:this.sortField,
    appliedFilters:this.appliedFilters,
    sortOrder:this.sortOrder
  };
  this.userRoleDefaultFeaturesService.ExportDefaultFeatures(this.applicationFeaturesSearchParam).subscribe(res => {
  var blob = new Blob([res.body], { type: res.body.type });
  const file = new File([blob],"UserDefaultFeatures.xlsx", { type: res.body.type });
  fs.saveAs(file);
  });
}

}
